var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"terms-page"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"page-title"},[_vm._v("Regulamin korzystania z aplikacji")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }